import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SearchComponent } from './search/search.component';

import { CardsModule } from '@sparro/app/shared/components/cards/cards.module';
import { LoaderModule } from '@sparro/app/shared/components/loader/loader.module';
import { LayoutModule } from '@sparro/app/shared/components/layout/layout.module';
import { ButtonsModule } from '@sparro/app/shared/components/buttons/buttons.module';
import { FilterSortDialogComponent } from './filter-sort-dialog/filter-sort-dialog.component';

import { MaterialModule } from '@sparro/app/material.module';
import { FlexLayoutModule } from '@angular/flex-layout';

import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { FieldsModule } from '@sparro/app/shared/components/forms/fields/fields.module';

@NgModule({
  declarations: [
    SearchComponent,
    FilterSortDialogComponent,
  ],
  entryComponents: [
    FilterSortDialogComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CardsModule,
    LoaderModule,
    LayoutModule,
    ButtonsModule,
    MaterialModule,
    FlexLayoutModule,
    NgxMatSelectSearchModule,
    FieldsModule,
  ]
})
export class SearchModule { }
